<template>
    <svg aria-hidden="true" width="40" height="61" viewBox="0 0 40.25 61.3469" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.31764 0C0.167138 4.96355 0.224625 9.73285 2.48438 14.3079C4.67513 18.7398 8.24588 21.904 13.1966 23.7954C23.4604 27.7212 35.2594 23.2229 39.5086 13.945L2.32336 0.00510898L2.31764 0Z"
            fill="currentColor" />
        <path
            d="M0 43.128C0.115 48.4596 2.17927 52.8455 6.19852 56.2909C10.097 59.6289 14.7315 61.3107 20.102 61.3464C31.2398 61.418 40.2385 53.1727 40.25 43.128H0Z"
            fill="currentColor" />
        <path
            d="M0 24.9101C0.115 30.2417 2.17927 34.6276 6.19852 38.0729C10.097 41.4109 14.7315 43.0927 20.102 43.1285C31.2398 43.2001 40.2385 34.9548 40.25 24.9101H0Z"
            fill="currentColor" />
    </svg>
</template>
